import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import s from './SignalTranslationEquation.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import EquationConstant from './EquationConstant';
import { WidgetVisibility } from '../../utils/widgetManager';

const EquationConstantTable = ({
  SelectedSignalTranslationEquationConstant,
  setAddHandler,
  setEditHandler,
  disableMode,
  disableModeHandler,
  selectedSignalTranslationEquationConstantId,
  selectedEquationConstantIdentifier,
  setSignalTranslationEquationConstantList,
  changeSignalTranslationEquationConstant,
  setSignalTranslationEquationCustomError,
  userProfileWidgets,
  UpdateAllowed,
  intl
}) => {
  let isEdit = false;

  if (selectedSignalTranslationEquationConstantId > 0 || selectedEquationConstantIdentifier.length > 0) {
    isEdit = true;
  }

  const addNewCosntantHandler = () => {
    setAddHandler();
    disableModeHandler(true);
  };

  const fetchDataHandler = (signalTranslationEquationConstantId, identifier) => {
    setEditHandler(signalTranslationEquationConstantId, identifier);
    disableModeHandler(true);
  };

  const deleteDataHandler = (equationConstantId, identifer) => {
    if (equationConstantId > -1) {
      const constantList = SelectedSignalTranslationEquationConstant.EquationConstantList || [];
      let constantEquation = constantList.filter(item => {
        if (item.GuidIdentifier === identifer) return item;
      });

      if (constantEquation.length > 0 && constantEquation[0].IsDeletable === 0) {
        const messageText = intl.formatMessage({
          id: 'signalTranslationEquation.constant.signalTranslationexists',
          defaultMessage: 'Unable to delete, this constant is still is use in signalTranslations'
        });
        setSignalTranslationEquationCustomError(messageText, true);
      } else {
        let saveData = constantEquation[0];
        saveData.isDeleted = true;
        saveEquationConstantHandler(saveData);
      }
    }
  };

  const saveEquationConstantHandler = equationConstant => {
    let listData = SelectedSignalTranslationEquationConstant.EquationConstantList;

    if (equationConstant.SignalTranslationEquationConstantId > 0) {
      const updatedData = listData.map(x => (x.GuidIdentifier === equationConstant.GuidIdentifier ? { ...x, ...equationConstant } : x));
      setSignalTranslationEquationConstantList({
        EquationConstantList: updatedData
      });
    } else {
      let hasItem = listData.filter(item => {
        if (item.GuidIdentifier === equationConstant.GuidIdentifier) return item;
      });

      if (hasItem.length > 0) {
        const updatedData = listData.map(x => (x.GuidIdentifier === equationConstant.GuidIdentifier ? { ...x, ...equationConstant } : x));
        setSignalTranslationEquationConstantList({
          EquationConstantList: updatedData
        });
      } else {
        listData.push(equationConstant);
        setSignalTranslationEquationConstantList({
          EquationConstantList: listData
        });
      }
    }
  };

  const getConstantListData = () => {
    const constantList = SelectedSignalTranslationEquationConstant.EquationConstantList || [];
    let constantEquation = constantList.filter(item => {
      if (item.isDeleted !== true) return item;
    });
    return constantEquation;
  };

  const cancelEquationConstantHandler = () => {
    setEditHandler(-1, '');
    disableModeHandler(false);
  };

  const ConstantContent = (
    <EquationConstant
      isEdit={isEdit}
      selectedEquationConstant={SelectedSignalTranslationEquationConstant.SelectedEquationConstant}
      changeSignalTranslationEquationConstant={changeSignalTranslationEquationConstant}
      saveEquationConstant={saveEquationConstantHandler}
      cancelEquationConstantHandler={cancelEquationConstantHandler}
    />
  );

  let editorMain = (
    <tr>
      <td colSpan="10">{ConstantContent}</td>
    </tr>
  );

  let newRowClass = SelectedSignalTranslationEquationConstant.showAddEditScreen && selectedSignalTranslationEquationConstantId === 0 ? s.newRow : '';

  return (
    <div className="">
      <Row className={s.breakRow}>
        <Col sm={6} lg={8}>
          <h4 className={s.subheading}>
            <FormattedMessage id="signalTranslationEquation.constant" defaultMessage="SignalTranslation Constants" />
          </h4>
        </Col>
        <Col sm={6} lg={4}>
          <Button
            className={s.addbutton}
            style={WidgetVisibility(userProfileWidgets, 'SIGNALTRANSLATIONEQUATIONCONSTADD')}
            onClick={addNewCosntantHandler}
            disabled={disableMode}
            data-unittest="addSetpointButton"
          >
            + <FormattedMessage id="modelVariant.addNew" defaultMessage="ADD NEW" />
          </Button>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <Table variant className={s.wsInnerTable}>
            <thead>
              <tr>
                <th className="d-none d-md-table-cell">
                  <FormattedMessage id="signalTranslationEquation.constant.name" defaultMessage="Name" />
                </th>
                <th className="d-none d-md-table-cell">
                  <FormattedMessage id="signalTranslationEquation.constant.description" defaultMessage="Description" />
                </th>
                <th className="d-none d-md-table-cell"></th>
              </tr>
            </thead>
            <tbody>
              {getConstantListData().map(n => {
                return (
                  <Fragment key={n.GuidIdentifier}>
                    <tr key={n.SignalTranslationEquationConstantId} data-unittest="EquationConstantList">
                      <td className="d-none d-md-table-cell">{n.Name}</td>
                      <td className="d-none d-md-table-cell">{n.Description}</td>
                      <td className={s.btnCol}>
                        {UpdateAllowed && (
                          <div className={s.buttonContainer}>
                            <Button
                              variant="outline-secondary"
                              className={s.changeButton}
                              href="#"
                              onClick={fetchDataHandler.bind(this, n.SignalTranslationEquationConstantId, n.GuidIdentifier)}
                              disabled={disableMode}
                              data-unittest="changeData"
                              style={WidgetVisibility(userProfileWidgets, `SIGNALTRANSLATIONEQUATIONCONSTUPDATE`)}
                            >
                              <FormattedMessage id="common.ledit" defaultMessage="Edit" />
                            </Button>
                            <Button
                              variant="outline-secondary"
                              className={s.removeButton}
                              href="#"
                              onClick={deleteDataHandler.bind(this, n.SignalTranslationEquationConstantId, n.GuidIdentifier)}
                              disabled={disableMode}
                              data-unittest="deleteData"
                              style={WidgetVisibility(userProfileWidgets, `SIGNALTRANSLATIONEQUATIONCONSTDELETE`)}
                            >
                              <FormattedMessage id="signalTranslationEquation.constant.remove" defaultMessage="Remove" />
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                    {SelectedSignalTranslationEquationConstant.showAddEditScreen &&
                      selectedEquationConstantIdentifier === n.GuidIdentifier &&
                      editorMain}
                  </Fragment>
                );
              })}
            </tbody>
          </Table>
          <div className={newRowClass}>
            {SelectedSignalTranslationEquationConstant.showAddEditScreen && selectedEquationConstantIdentifier === '' && ConstantContent}
          </div>
        </Col>
      </Row>
    </div>
  );
};

EquationConstantTable.propTypes = {
  setEditHandler: PropTypes.func.isRequired,
  selectedSignalTranslationEquationConstantId: PropTypes.number,
  SelectedSignalTranslationEquationConstant: PropTypes.object.isRequired,
  UpdateAllowed: PropTypes.bool,
  disableMode: PropTypes.bool,
  disableModeHandler: PropTypes.func.isRequired
};

export default injectIntl(EquationConstantTable);
